import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-close-project',
  templateUrl: './close-project.component.html',
  styleUrls: ['./close-project.component.scss']
})
export class CloseProjectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
